export default __webpack_public_path__ + "static/media/data_setting_10.a225dddf.png";